import { RouteKey } from "@/providers/types";

export const accountTabs: {
  label: string;
  route: string;
  id: string;
  routeKey: RouteKey;
}[] = [
  {
    label: "AI Tuning",
    route: `ai-tuning`,
    id: "account-settings-tab-ai-tuning",
    routeKey: "account-settings.ai-tuning",
  },
  {
    label: "Hero Image",
    route: `hero-image`,
    id: "account-settings-tab-hero-image",
    routeKey: "account-settings.hero-image",
  },
  {
    label: "Brand kit",
    route: `brand-kit`,
    id: "account-settings-tab-brand-kit",
    routeKey: "account-settings.brand-kit",
  },
  {
    label: "Profile",
    route: `profile`,
    id: "account-settings-tab-profile",
    routeKey: "account-settings.profile",
  },
  {
    label: "Plans",
    route: `plans`,
    id: "account-settings-tab-plans",
    routeKey: "account-settings.plans",
  },
  {
    label: "Sender details",
    route: `sender-details`,
    id: "account-settings-tab-sender-details",
    routeKey: "account-settings.sender-details",
  },
  {
    label: "Verify DNS Settings",
    route: `verify-dns-settings`,
    id: "account-settings-tab-verify-dns-settings",
    routeKey: "account-settings.dns",
  },
];
